import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useContext,
  Suspense,
} from 'react';

import { CLIPSTORES } from '../../constants/apiUrls/apiUrls';
import callApi from '../../utils/callApi';
import { UserContext } from '../../context';
import './ClipStore.css';
import '../../css/utils/flex.css';
import '../AnchorPage/css/Anchor.css';
import PayPerViewStore from '../../store/PayPerViewStore';
import ClipStoreTitleImage from '../../assets/Clip Store title.png';
import { buildAnchorLink } from '../../utils/helpers';


const FeaturedSection = React.lazy(() => import('../../components/anchorComponents/FeaturedSection'));


const nakedNewsLiveId = 241;
const nakedNewsLive = { id: nakedNewsLiveId, name: 'Naked News Live' };
const ALL_OPTION = { name: 'All' };
const entriesPerPage = 12;
//    add naked news live info since it isn't returned by fanzones endpoint


function ClipStorePage(props) {
  const user = useContext(UserContext);
  const { location } = props;
  const [anchors, setAnchors] = useState([]);
  const [selectedAnchor, setSelectedAnchor] = useState(ALL_OPTION);
  const [searchText, setSearchText] = useState('');
  const [dropdownOption, setDropdownOption] = useState('All');
  const [showOptions, setShowOptions] = useState(false);
  const [banStatus, setBanStatus] = useState(false);
  const [anchorPageLink, setAnchorPageLink] = useState('');

  useEffect(() => {
    callApi(CLIPSTORES, 'get').then((res) => {
      const { data } = res;
      data.push(nakedNewsLive);
      data.push(ALL_OPTION);
      setAnchors(res.data);
    });

    return () => PayPerViewStore.setPayPerViewNav('New');
  }, []);

  const clearInput = useCallback(() => {
    setSearchText('');
  }, []);

  const setAnchor = useCallback(() => {
    const searchResult = anchors.find((a) =>
      a.name.replaceAll(' ', '').toLowerCase() === searchText.replaceAll(' ', '').toLowerCase());

    if (searchResult !== undefined) {
      setSelectedAnchor(searchResult);
      PayPerViewStore.setShouldRefreshItemsList(true);
    }
    clearInput();
  }, [searchText]);

  const setSelectedAnchorToSearch = useCallback((e) => {
    setShowOptions(false);
    const selectedOption = e.target.innerText;
    if (selectedOption === 'All') {
      setDropdownOption('All');
    } else {
      setDropdownOption('Anchors');
    }
    setSearchText(selectedOption);
    const searchResult = anchors.find((a) =>
      a.name.replaceAll(' ', '').toLowerCase() === selectedOption.replaceAll(' ', '').toLowerCase());
    if (searchResult !== undefined) {
      setSelectedAnchor(searchResult);
      PayPerViewStore.setShouldRefreshItemsList(true);
    }
    clearInput();
  }, [searchText, anchors]);

  const handleOptionChange = useCallback((e) => {
    const { value } = e.target;
    switch (value) {
      case 'All':
        setDropdownOption(value);
        break;
      case 'Naked News Live':
        setDropdownOption(value);
        setSelectedAnchor(nakedNewsLive);
        setSearchText('Naked News Live');
        setAnchor();
        PayPerViewStore.setShouldRefreshItemsList(true);
        break;
      case 'Anchors':
        setDropdownOption(value);
        break;
      default:
        setDropdownOption('All');
    }
  }, []);

  useEffect(() => {
    setShowOptions(searchText.length > 0);
  }, [searchText]);

  const featuredSection = useMemo(() => (
    <Suspense fallback={null}>
      <FeaturedSection
        anchorName={selectedAnchor.name}
        anchors={anchors}
        dropdownOption={dropdownOption}
        extractIdFromSlug={String(selectedAnchor.id || nakedNewsLiveId)}
        handleOptionChange={handleOptionChange}
        id={String(selectedAnchor.id || nakedNewsLiveId)}
        isClipStorePage={true}
        location={location}
        pageItemsShown={entriesPerPage}
        setBanStatus={setBanStatus}
        showClipStore={true}
        user={user}
      />
    </Suspense>
  ), [
    dropdownOption,
    handleOptionChange,
    location,
    selectedAnchor.id,
    selectedAnchor.name,
    user,
    anchors,
  ]);

  const onButtonClick = useCallback(() => {
    setShowOptions(true);
  }, [setShowOptions]);

  const dropdownMenu = useMemo(() => (
    showOptions && <div className="search-bar-options">
      {anchors.filter((a) =>
        a.name.toLowerCase().includes(searchText.toLowerCase())).
        map((anchor) => (
          <div
            key={anchor.id}
            value={anchor.name}
            onClick={setSelectedAnchorToSearch}
          >
            {anchor.name}
          </div>
        ))}
    </div>
  ), [searchText, showOptions, anchors, setSelectedAnchorToSearch]);

  const anchorOptions = useMemo(() => (
    anchors?.map((anchor) => (
      <button key={anchor.name} className="anchor-option" onClick={setSelectedAnchorToSearch}>
        {anchor.name}
      </button>
    ))
  ), [anchors, setSelectedAnchorToSearch]);

  const getCurrentAnchorLink = useCallback(() => {
    if (selectedAnchor.name !== 'All') {
      return `/${buildAnchorLink(selectedAnchor)}`;
    }

    return '#';
  }, [selectedAnchor]);

  useEffect(() => {
    setAnchorPageLink(getCurrentAnchorLink());
  }, [getCurrentAnchorLink, selectedAnchor]);

  return (
    <div className="clip-store-page flex-1" id="anchors-show">
      <div className="clip-store-desc">
        <div className="search-bar-wrapper">
          <h1 className="bold-text text-center">
            <div className="clip-store-title">
              <img alt="Clip Store" src={ClipStoreTitleImage} />
            </div>
          </h1>
          <h4 className="text-center clip-store-sub-head">Search for Clip Store Content from your favorite Anchors</h4>
        </div>
      </div>
      <div className="anchor-selection">
        {anchorOptions}
      </div>
      <div className="search-bar-container">
        <div className="search-bar">
          <a
            className="link-to-anchor-page clip-store-input"
            href={anchorPageLink}
            rel="noreferrer"
            target={dropdownOption === 'All' ? '_self' : '_blank'}
          >
            {selectedAnchor.name}
          </a>
          <button
            className="clip-store-input"
            id="clip-store-button"
            onClick={onButtonClick}
          >
            {selectedAnchor.name}
          </button>
        </div>
        {dropdownMenu}
      </div>
      {featuredSection}
    </div>);
}

export default ClipStorePage;
